import { HeaderContainer, StyledContainer, StyledTitle } from './styled-components'
import useTabBar from '@/containers/SubscriptionFormPageNew/SubscriptionForm/useTabBar'
import ExportLogs from './ExportLogs/ExportLogs'
import HistoricAuditLogs from './HistoricAuditLogs/HistoricAuditLogs'
import ChangeUser from './ChangeUser/ChangeUser'
import ZohoButton from './ZohoButton/ZohoButton'
import AbandonContract from './AbandonContract/AbandonContract'
import Comments from './Comments/Comments'
const Tools = () => {
  const { t } = useTabBar()

  return (
    <StyledContainer>
      <HeaderContainer>
        <StyledTitle>{t('subscriptionTools:tools.module_title')}</StyledTitle>
      </HeaderContainer>
      <ZohoButton />
      <ExportLogs />
      <HistoricAuditLogs />
      <ChangeUser />
      <AbandonContract />
      <Comments />
    </StyledContainer>
  )
}

export default Tools
